import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'Company', href: '#company' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Process', href: '#process' },
    { label: 'Why TM RUSH', href: '#why-tm-rush' },
    { label: 'Team', href: '/#team' },
    { label: 'Brazil Watch', href: '/brazil-watch' },
    { label: 'Order online', href: '/order' },
    { label: 'About', href: '/about' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="bg-text text-white py-12 relative scroll-mt-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.label}>
                  {item.href.startsWith('/') && !item.href.includes('#') ? (
                    <Link
                      to={item.href}
                      onClick={item.label === 'Home' ? scrollToTop : undefined}
                      className="text-gray-400 hover:text-white"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <a href={item.href} className="text-gray-400 hover:text-white">
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Office</h3>
            <div className="space-y-2 text-gray-400">
              <p>Brazil</p>
              <p>Av. Caí, 284, Cristal</p>
              <p>Porto Alegre/RS, 90810-120</p>
              <p>
                WhatsApp Support:{' '}
                <a href="https://wa.me/5551995756523" className="hover:text-white" target="_blank" rel="noopener noreferrer">
                  +55 51 99575-6523
                </a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-gray-400">
              <p>
                <a href="mailto:contact@tmrush.com" className="hover:text-white">
                  contact@tmrush.com
                </a>
              </p>
              <p>Mon - Fri: 9am - 6pm (BRT)</p>
            </div>
          </div>
        </div>

        <div className="border-t border-text/30 pt-8 text-center text-gray-400 space-y-2">
          <p>© {new Date().getFullYear()} TM RUSH® - Powered by Marcas Já. All Rights Reserved.</p>
          <p className="text-sm">
            Operated by Marcas Já, Registro de Marcas Ltda. CNPJ 41.303.167/0001-09
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
